import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { FaGlobe } from "react-icons/fa";

function LanguageChangerStoreFront({ displayType = "buttons" }) {
  const business = useSelector((state) => state.bussiness.business);
  const navigate = useNavigate();
  const { businessName, bussinessUuid } = useParams();

  const { i18n } = useTranslation();

  // On mount, set language from localStorage or business default
  useEffect(() => {
    const savedLang = localStorage.getItem("lng");
    
    if (savedLang) {
      i18n.changeLanguage(savedLang);
    } else if (business?.language) {
      i18n.changeLanguage(business.language);
    }
  }, [business, i18n]);

  const handleOpenLanguagePage = () => {
    if (businessName && bussinessUuid) {
      navigate(`/${businessName}/store/${bussinessUuid}/select-language`);
    } else if (bussinessUuid) {
      navigate(`/store/${bussinessUuid}/select-language`);
    } else {
      navigate("/select-language");
    }
  };

  const selectedLanguage = localStorage.getItem("lng") || business?.language || "en";

  const languages = [
    { code: "en", label: "English" },
    { code: "hi", label: "हिंदी" },
    { code: "pa", label: "ਪੰਜਾਬੀ" },
    { code: "mr", label: "मराठी" },
    { code: "gu", label: "ગુજરાતી" },
    { code: "ta", label: "தமிழ்" },
    { code: "te", label: "తెలుగు" },
    { code: "kn", label: "ಕನ್ನಡ" },
    { code: "ml", label: "മലയാളം" },
    { code: "bn", label: "বাংলা" },
    { code: "or", label: "ଓଡିଆ" },
    { code: "ur", label: "اردو" },
  ];

  return (
    <div className='App'>
      {displayType === "buttons" ? (
        <button
          onClick={handleOpenLanguagePage}
          className="flex items-center gap-2 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
          title="Select Language"
        >
          <FaGlobe className="text-sm" />
          <span>Language: {languages.find(l => l.code === selectedLanguage)?.label || "English"}</span>
        </button>
      ) : (
        <button
          onClick={handleOpenLanguagePage}
          className="flex items-center gap-2 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
          title="Select Language"
        >
          <FaGlobe className="text-sm" />
          <span>{languages.find(l => l.code === selectedLanguage)?.label || "Select Language"}</span>
        </button>
      )}
    </div>
  );
}

export default LanguageChangerStoreFront;